import React from 'react';
import FadeIn from '@components/atoms/FadeIn';
import About from '@containers/About';
import Head from 'next/head';
import Announcements from '@containers/Announcements';
import brand from '@lib/brand';
const HomePage: React.FC<{}> = () => {
  return (
    <FadeIn>
      <Head>
        <title>{`${brand.brand} | About`}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <Announcements />
      <About />
    </FadeIn>
  );
};

export default HomePage;
